module.exports = __webpack_public_path__ + "static/media/sonicstop-3.cba04af7.jpg";